var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29814_1046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3972 6.22201C14.3472 6.22201 16 7.02756 16 7.99978C16 8.99978 14.3472 9.77756 13.3972 9.77756H10.1583L7.36667 14.6637C7.20833 14.9414 6.91389 15.1109 6.59444 15.1109H5.03333C4.73889 15.1109 4.525 14.8276 4.60556 14.5442L5.96667 9.77756H3.11111L1.91111 11.3776C1.82778 11.4887 1.69444 11.5553 1.55556 11.5553H0.388889C0.172222 11.5553 0 11.3803 0 11.1664C0 11.1303 0.00555556 11.0942 0.0138889 11.0581L0.888889 7.99978L0.0138889 4.94145C0.00277778 4.90534 0 4.86923 0 4.83312C0 4.61645 0.175 4.44423 0.388889 4.44423H1.55556C1.69444 4.44423 1.82778 4.51089 1.91111 4.622L3.11111 6.22201H5.96944L4.60833 1.45534C4.525 1.17201 4.73889 0.888672 5.03333 0.888672H6.59444C6.91389 0.888672 7.20833 1.06089 7.36667 1.33589L10.1583 6.22201H13.3972Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29814_1046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.4bc0c9c5e703275a11a2f58274658587.svg";
export { ForwardRef as ReactComponent };